<template>
  <a-checkbox
    v-model:checked="model"  
    class="checkbox-facade"
    :disabled="disabled"
    @change="$emit('change')"
  >
    <slot></slot>
  </a-checkbox>
</template>

<script setup>
  /**
   * Компонент-фасад для компонента <a-checkbox/> из библиотеки ant-design-vue.
   * Его нужно использовать в коде компонентов вместо <a-checkbox/>.
   * 
   * Пример использования:
   * <checkbox-facade
   *   v-model="checked"
   *   @change="onChange"
   * >
   *   Согласен
   * </checkbox-facade>
   */

  import { defineModel } from 'vue';

  const model = defineModel();

  defineProps({
    // Disable checkbox
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  defineEmits(['change']);
</script>

<style lang="scss" scoped>
  .checkbox-facade.ant-checkbox-wrapper {
    font-family: 'Nunito Sans', sans-serif;
    user-select: none;

    &:hover .ant-checkbox .ant-checkbox-inner {
      border-color: #579b15;
    }

    &:hover + .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #72c81e;
      border-color: transparent;
    }

    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: #72c81e;
    }

    .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
      outline: none;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #72c81e !important;
      border-color: #72c81e !important;
    }

    .ant-checkbox-checked:after {
      border-color: #72c81e !important;
    }
  }
</style>